module.exports = __webpack_public_path__ + "img/imghuanxinggray.77c5c852.png";